// Fireplace: the hearth glows up from the bottom edge and flickers, and
// embers rise off it, drifting and fading before they reach the top.
const EMBERS = [
  { x: 10, r: 0.8, drift: 4, delay: 0, dur: 3.6, opacity: 0.8 },
  { x: 21, r: 0.6, drift: -3, delay: 1.9, dur: 4.4, opacity: 0.6 },
  { x: 33, r: 1.0, drift: 5, delay: 0.7, dur: 3.9, opacity: 0.75 },
  { x: 45, r: 0.6, drift: -4, delay: 2.8, dur: 4.8, opacity: 0.55 },
  { x: 56, r: 0.9, drift: 3, delay: 1.2, dur: 3.4, opacity: 0.8 },
  { x: 67, r: 0.7, drift: -5, delay: 3.4, dur: 4.2, opacity: 0.6 },
  { x: 78, r: 1.0, drift: 4, delay: 0.4, dur: 4.0, opacity: 0.7 },
  { x: 90, r: 0.6, drift: -3, delay: 2.2, dur: 4.6, opacity: 0.55 },
];

export default function AmbianceFireplaceAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--fireplace"
      aria-hidden="true"
    >
      <span className="mode-tile__fireplace-glow" />
      <svg
        className="mode-tile__fireplace-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {EMBERS.map((ember, index) => (
          <circle
            key={`ember-${index}`}
            className="mode-tile__fireplace-ember"
            cx={ember.x}
            cy={42}
            r={ember.r}
            style={{
              "--ember-peak": ember.opacity,
              "--ember-drift": `${ember.drift}px`,
              animationDelay: `-${ember.delay}s`,
              animationDuration: `${ember.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
